import React from "react";
import { Badge } from "antd";
import dayjs from "dayjs";

const ConversationListItem = ({
  ovr,
  isActive,
  getStatusBadge,
  onClick,
  unreadCount = 0,
}) => {
  const statusBadge = getStatusBadge(ovr.status);
  const lastComment =
    ovr.comments && ovr.comments.length > 0
      ? ovr.comments[ovr.comments.length - 1]
      : null;

  return (
    <div
      className={`p-4 border-b border-gray-100 cursor-pointer transition-all ${
        isActive
          ? "bg-blue-50 border-l-4 border-l-[#298d9f]"
          : "hover:bg-gray-50"
      }`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-1">
        <h3 className="font-semibold text-sm text-gray-900 truncate pr-2 flex-1">
          {ovr.title}
        </h3>
        {unreadCount > 0 && <Badge count={unreadCount} size="small" />}
      </div>

      <p className="text-xs text-gray-600 truncate mb-2">
        {lastComment ? lastComment.comment : ovr.body}
      </p>

      <div className="flex items-center justify-between">
        {ovr.updatedAt == null ? (
          <span className="text-xs text-gray-400">
            {dayjs(`${ovr.createdAt}Z`).format("h:mm A")}
          </span>
        ) : (
          <span className="text-xs text-gray-400">
            {/* {dayjs(`${lastComment?.createdAt}Z` || `${ovr.createdAt}Z`).format('h:mm A')} */}
            {dayjs(`${ovr.updatedAt}Z`).format("h:mm A")}
          </span>
        )}

        <span
          className="text-xs px-2 py-0.5 rounded-full"
          style={{
            backgroundColor: `${statusBadge.color}15`,
            color: statusBadge.color,
          }}
        >
          {statusBadge.text}
        </span>
      </div>
    </div>
  );
};

export default ConversationListItem;
